define(["marionette", "./template/shareResponseLinkModalTemplate.html"], function (
  Marionette,
  ShareResponseLinkModalTemplate,
) {
  "use strict";

  return {
    shareResponseLinkModalView: Marionette.ItemView.extend({
      template: ShareResponseLinkModalTemplate,
      triggers: {
        "change #shareLiveResponse": "linkType:live",
        "change #shareWorkingResponse": "linkType:working",
        "click #copyResponseLink": "copy:responseLink",
        "click #doneButton": "done",
      },
      ui: {
        responseLink: "#responseLink",
      },
      onRender: function () {
        this.constructor.__super__.onRender.call(this);
        setTimeout(() => this.selectResponseLink(), 100);
      },
      getResponseLink: function () {
        return this.ui.responseLink.val();
      },
      setResponseLink: function (responseLink) {
        this.ui.responseLink.val(responseLink);
        this.selectResponseLink();
      },
      selectResponseLink: function () {
        const responseLinkEl = this.ui.responseLink[0];
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(responseLinkEl);
        selection.removeAllRanges();
        selection.addRange(range);
      },
    }),
  };
});
